import { getStaticAssetUrl } from '@/app/lib/utils/static-asset-url';
import gsap from 'gsap';
import { createStableResizeHandler } from '../viewport-utils';

export default function initAnimation(
    root: HTMLDivElement,
    footerBg: HTMLCanvasElement,
) {
    const frameCount = 360;
    footerBg.width = root.clientWidth;
    footerBg.height = root.clientHeight;
    const context = footerBg.getContext('2d')!;
    const currentFrame = (index: number) =>
        `${getStaticAssetUrl(
            `/home_footer/${index.toString().padStart(5, '0')}.jpg`,
        )}`;

    const images: HTMLImageElement[] = [];

    const bgs = {
        frame: 0,
    };

    for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);
        images.push(img);
    }

    const animation = gsap.to(bgs, {
        frame: frameCount - 1,
        snap: 'frame',
        ease: 'none',
        scrub: true,
        repeat: -1,
        duration: 8,
        onUpdate: render, // use animation onUpdate instead of scrollTrigger's onUpdate
    });

    images[0].onload = render;

    function render() {
        if (footerBg.width != root.clientWidth) {
            footerBg.width = root.clientWidth;
            footerBg.height = root.clientHeight;
        }

        const img = images[bgs.frame];
        const canvasRatio = footerBg.width / footerBg.height;
        const imgRatio = img.naturalWidth / img.naturalHeight;
        let sx, sy, sWidth, sHeight;

        if (imgRatio > canvasRatio) {
            // 图片比画布更宽
            sWidth = img.naturalHeight * canvasRatio;
            sHeight = img.naturalHeight;
            sx = (img.naturalWidth - sWidth) / 2;
            sy = 0;
        } else {
            // 图片比画布更高
            sWidth = img.naturalWidth;
            sHeight = img.naturalWidth / canvasRatio;
            sx = 0;
            sy = (img.naturalHeight - sHeight) / 2;
        }

        context.clearRect(0, 0, footerBg.width, footerBg.height);
        context.drawImage(
            img,
            sx,
            sy,
            sWidth,
            sHeight,
            0,
            0,
            footerBg.width,
            footerBg.height,
        );
    }

    const handleResize = createStableResizeHandler(() => {
        footerBg.width = root.clientWidth;
        footerBg.height = root.clientHeight;
        render(); // 确保在窗口大小改变时重新渲染画布
    });
    window.addEventListener('resize', handleResize);

    return () => {
        window.removeEventListener('resize', handleResize);
        animation.kill();
    };
}
